import { combineReducers } from 'redux';

import pageLayout from './page-layout';
import relationship from './relationship';
import fileSearch from './file-search';
import visitSearch from './visit-search';
import guestForm from './guest-form';
import householdMemberForm from './household-member-form';
import reservationSearch from './reservation-search';

export default combineReducers({
  pageLayout,
  relationship,
  fileSearch,
  visitSearch,
  guestForm,
  householdMemberForm,
  reservationSearch
});
